import { ChevronLeft } from '@mui/icons-material';
import { AppBar, Box, Button, Container, Stack, Toolbar, Typography } from '@mui/material';
import React from 'react';
import { Outlet, useNavigate} from 'react-router';
import { useRouter } from 'src/routes/hooks';
import Iconify from 'src/components/iconify';


const MinimalNavbar = () => {
  const router = useRouter();
  const navigate = useNavigate();
  const getBackUrl = () => {
    try {
      const params = new URLSearchParams(window.location.search);
      const returnUrl = params.get('returnUrl');

      const isAllowed = (urlStr) => {
        try {
          const u = new URL(urlStr, window.location.href);
          const allowed = [window.location.hostname, 'cmintradev.cybermeru.com', 'merudesk.com'];
          return allowed.some((a) => u.hostname === a || u.hostname.endsWith(`.${a}`));
        } catch (e) {
          return false;
        }
      };
      // if developer forgot to pass:returnUrl, browser still know the previous page using referrer.
      if (returnUrl && isAllowed(returnUrl)) return returnUrl;
      if (document.referrer && isAllowed(document.referrer)) return document.referrer;
      // After refresh:returnUrl gone,referrer gone,therefore localStorage still exists.
      const tenantHost = localStorage.getItem('merudesk.selectedTenantHost');
      if (tenantHost) {
        const protocol = window.location.protocol || 'https:';
        return `${protocol}//${tenantHost}/auth/jwt/login`;
      }
    } catch (e) {
      // ignore and fallback to root
    }

    return '/';
  };

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: 'rgba(255, 255, 255, 0.85)',
        backdropFilter: 'blur(8px)',
        borderBottom: 1,
        borderColor: 'divider',
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{ height: 60, justifyContent: 'space-between' }}>
          {/* Logo Section */}
          <Stack
            direction="row"
            alignItems="center"
            spacing={1.5}
            sx={{ cursor: 'pointer' }}
            // onClick={() => router.push(getBackUrl())}
          >
            <Box
              component="img"
              src="/assets/MeruDesk.png"
              alt="MeruDesk"
              sx={{
                width: 200,
                height: 'auto',
                // objectFit: 'contain',
                display: 'block',
              }}
            />
          </Stack>

          {/* Back Button */}
          <Box>
                    <Button
                      onClick={() => router.push(getBackUrl())}
                      startIcon={<Iconify icon="solar:home-2-bold-duotone" width={18} />}
                      variant="contained"
                      size="small"
                      sx={{
                        fontWeight: 700,
                        px: 1.5,
                        py: 0.6,
                        borderRadius: 1,
                        bgcolor: 'primary.main',
                        color: 'common.white',
                        boxShadow: (theme) => `0 4px 12px ${theme.palette.primary.main}33`,
                        transition: 'all 0.3s',
                        '&:hover': {
                          bgcolor: 'primary.dark',
                          transform: 'translateY(-1px)',
                          boxShadow: (theme) => `0 8px 16px ${theme.palette.primary.main}44`,
                        },
                      }}
                    >
                      Back to Home
                    </Button>
                  </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

const Footer = () => (
  <Box
    component="footer"
    sx={{ bgcolor: '#FFFFFF', pt: 4, pb: 3, borderTop: 1, borderColor: 'divider', mt: 6 }}
  >
    <Container maxWidth="lg">
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Stack direction="row" alignItems="center" >
          <Box
            component="img"
            src="/assets/MeruDeskShort.png"
            alt="MeruDesk"
            sx={{
              width: 80,
              height: 'auto',
              // objectFit: 'contain',
              display: 'block',
            }}
          />
          <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'text.primary' }}>
            MeruDesk by CyberMeru
          </Typography>
        </Stack>
        <Typography variant="body2" color="text.secondary">
          © {new Date().getFullYear()} CyberMeru Technologies Pvt. Ltd. All rights reserved.
        </Typography>
      </Box>
    </Container>
  </Box>
);

const PolicyLayout = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      bgcolor: 'background.paper',
      position: 'relative',
    }}
  >
    <MinimalNavbar />
    <Outlet />

    <Footer />
  </Box>
);

export default PolicyLayout;
